/*
 * Copyright (c) 2021 NOOGA DEVELOPMENT, All rights reserved.
 * Author Julia Romanovskaya <julia.romanovskaya@noogadev.com>
 */

import * as React from 'react';
import { RouteParam, RouteId } from '../../../router/routes';
import { TurnoversTableData } from './TurnoverConfig';
import { Table, TableBody, TableHead, TableRow } from '@mui/material';

export interface ListTableLinkData<T extends object> {
    routeId?: RouteId;
    routeParamName: RouteParam;
    routeParamKeyForValue: keyof T;
}

export interface ListTableColumnConfig<T extends object> {
    keyForValue: keyof T;
    translatePath: string;
    isHidden?: boolean;
    isSearchable?: boolean;
    isSortable?: boolean;
    link?: ListTableLinkData<T>;
    isBold?: boolean;
    isClickable?: boolean;
    isWithTooltip?: boolean;
    displayAsColorBar?: boolean;
    displayAsColorText?: boolean;
    displayCustomCell?: boolean;
    displayCustomHeader?: boolean;
    cellTestId?: string;
    align?: 'right' | 'left' | 'center';
    minWidth?: number;
    maxWidth?: number;
    width?: number | string;
}

export type TurnoversColumnConfig = Pick<
    ListTableColumnConfig<TurnoversTableData>,
    | 'keyForValue'
    | 'translatePath'
    | 'isHidden'
    | 'link'
    | 'isBold'
    | 'isWithTooltip'
    | 'align'
    | 'minWidth'
    | 'maxWidth'
    | 'width'
>;

export enum TurnoverReportType {
    ByPeriod = 'RegistryScreens.byPeriods',
    ByObject = 'RegistryScreens.byObjects',
    ByCashBox = 'RegistryScreens.byCashboxes',
}

export interface Incapacitated {
    incapacitated: boolean;
}

export const getVirtuosoTableComponents = (isUnfoldedLess: boolean) => {
    return {
        Table: (props: object) => (
            <Table {...props} style={{ borderCollapse: 'separate' }} size={isUnfoldedLess ? 'small' : 'medium'} />
        ),
        TableHead: React.forwardRef<HTMLTableSectionElement>((props, ref) => <TableHead {...props} ref={ref} />),
        TableRow: (props: object) => <TableRow {...props} hover />,
        TableBody: React.forwardRef<HTMLTableSectionElement>((props, ref) => <TableBody {...props} ref={ref} />),
    };
};
